const TIMEOUT_ERROR_MESSAGE = 'Timed Out';
const DEFAULT_TIMEOUT_MILLISECONDS = 3000;

const rejectAfterMilliseconds = (milliseconds) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error(TIMEOUT_ERROR_MESSAGE));
    }, milliseconds);
  });
};

/**
 * Waits a certain amount of time for an asynchronous operation to complete before throwing an
 * error.
 * @param {Function} asyncAction - Operation to attempt, must return a Promise.
 * @param {number} milliseconds - Maximum amount of time to wait before throwing an error, in
 * milliseconds.
 * @returns {Promise} - Either: (1) resolves to the value that the Promise returned by asyncAction
 * resolved to; or (2) rejects with the value that the Promise returned by asyncAction rejected
 * with; or (3) rejects with an Error if the operation timed-out.
 */
const timeout = ({
  asyncAction,
  milliseconds = DEFAULT_TIMEOUT_MILLISECONDS,
}) => {
  return Promise.race([asyncAction(), rejectAfterMilliseconds(milliseconds)]);
};

export default timeout;

export const unitTestExports = {
  DEFAULT_TIMEOUT_MILLISECONDS,
  rejectAfterMilliseconds,
};
